module.exports = __webpack_public_path__ + "static/media/logo-gpx-ecofi.67f0ae6a.png";